var _ = require('lodash');
window.$ = window.jQuery = require('jquery');

require('sweetalert');
require('slick-carousel');
//require('materialize-css');
//require ('jquery-modal');

require('./views');
require('./libreries/configuration');